import { IconRefresh } from "@tabler/icons-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { useI18n } from "@/contexts/I18nContext";

export function MenuSearchBar({ search, setSearch, onRefresh }) {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const { t } = useI18n();

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await onRefresh();
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <div className="mt-2 flex w-full items-center gap-2">
      <Input
        type="text"
        placeholder={t("menu.search")}
        value={search}
        onChange={(event) => setSearch(event.target.value)}
        className="flex-1"
      />
      <Button
        type="button"
        onClick={handleRefresh}
        size="icon"
        variant="ghost"
        className="rounded"
        title={t("common.refresh")}
      >
        <IconRefresh
          size={18}
          className={isRefreshing ? "animate-spin" : ""}
        />
      </Button>
    </div>
  );
}
